<template>
  <div class="all">
    <div class="nei">

      <el-row :gutter="10">
        <el-col :span="6">
          <div class="grid-content"><p class="p1">{{ itemData.introductionData.p1 }}</p></div>
          <div class="lineBox"></div>
        </el-col>
        <el-col :span="18">
          <div class="grid-content"><p class="p2">{{ itemData.introductionData.p2 }}</p></div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <div class="grid-content">
            <div class="iconBox" @click="handleMore">
              <el-image
                src="https://www.victrum.com/image/sy/icon.png"
                :fit="contain"></el-image>
            </div>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="grid-content"><p class="p3">{{ itemData.introductionData.p3 }}</p></div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<style>
.iconBox{
  height: 100%;
  margin-top: 10px;
}
.lineBox {
  height: 2px;
  width: 106px;
  background: #d8d8d8;
  margin-top: 20px;
}
.p1 {
  font-family: SourceHanSansCN;
  font-size: 30px;
  color: #333333;
  text-align: justify;
}

.p2 {
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0.3px;
  text-align: justify;
  line-height: 28px;
}

.p3 {
  font-family: SourceHanSansCN;
  font-size: 12px;
  color: #666666;
  letter-spacing: 0.2px;
  text-align: justify;
  line-height: 24px;
}

.all {
  width: 100%;
  min-height: 460px;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  background-color: #FFFFFF;
}

.nei {
  width: 61.25%;
  min-height: 297px;
  background-color: #FFFFFF;
}
</style>
<script>
import {Data} from "../js/image/introduction";

export default {
  name: "introduction",
  data() {
    return {
      dataAll: Data,
      itemData: {},
    }
  },
  mounted() {
    let that = this;

    for(let index in that.dataAll){
      let itemData= that.dataAll[index];
      if(that.$parent.$parent.message == itemData.type){
        that.itemData = itemData;
        break;
      }
    }
  },
  methods:{
    //查看更多
    handleMore(){
      this.$router.push('/aboutUs?path=gsjj');
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/image/introduction.vue